export interface FuelSupplierAddRecord {
  id: number;
}
